import React from "react";
import { FeedbackMark } from "./FeedbackIcons";
import "./FeedbackLauncher.css";

export function FeedbackLauncher({ hidden = false, onClick }) {
  if (hidden) return null;
  return (
    <button type="button" className="fb-launcher" aria-label="Send feedback" onClick={onClick}>
      <FeedbackMark size={20} />
    </button>
  );
}
